import React from "react"

import Head from "../components/seo";
import PageLayout from "../components/layoutPage";

import FirstSection from "../components/firstsection";
import SecondSection from "../components/secondsection"
import ThirdSection from "../components/thirdsection"
import FourthSection from "../components/fourthsection"
import FifthSection from "../components/fifthsection"
import Contact from "../components/contact";

const Home = () => {
  return (
    <PageLayout notHome={false}>
      <Head pageTitle="Home" />
      <FirstSection />
      <SecondSection />
      <ThirdSection />
      <FourthSection />
      <FifthSection />
      <Contact />
    </PageLayout>
  );
}

export default Home;